import React from "react";

export type SparkleIconAppearance = "landing" | "default";

type SparkleIconProps = {
  appearance?: SparkleIconAppearance;
  strokeColor?: string;
  fillColor?: string;
};

export const SparkleIcon: React.FC<SparkleIconProps> = ({
  appearance = "default",
  strokeColor = "currentColor",
  fillColor,
}) => {
  const fill =
    fillColor ?? (appearance === "landing" ? "none" : "currentColor");

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.59925 3.85089L6.15312 2.50576C6.19015 2.41584 6.27779 2.35714 6.37503 2.35714C6.47228 2.35714 6.55992 2.41584 6.59693 2.50576L7.15082 3.85089C7.47718 4.64346 8.10657 5.27285 8.89915 5.59922L10.2443 6.1531C10.3342 6.19011 10.3929 6.27775 10.3929 6.375C10.3929 6.47225 10.3342 6.55989 10.2443 6.59691L8.89915 7.15078C8.10657 7.47715 7.47718 8.10654 7.15082 8.89912L6.59693 10.2442C6.55992 10.3342 6.47228 10.3929 6.37503 10.3929C6.27779 10.3929 6.19015 10.3342 6.15312 10.2442L5.59925 8.89912C5.27289 8.10654 4.6435 7.47715 3.85092 7.15078L2.50579 6.59691C2.41587 6.55989 2.35718 6.47225 2.35718 6.375C2.35718 6.27775 2.41587 6.19011 2.50579 6.1531L3.85092 5.59922C4.6435 5.27285 5.27289 4.64346 5.59925 3.85089Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.1368 11.3884L14.4353 8.23479C14.4982 8.08191 14.6472 7.98214 14.8125 7.98214C14.9779 7.98214 15.1268 8.08191 15.1898 8.23479L16.4883 11.3884C16.8147 12.181 17.4441 12.8104 18.2367 13.1367L21.3902 14.4353C21.5431 14.4982 21.6429 14.6472 21.6429 14.8125C21.6429 14.9778 21.5431 15.1268 21.3902 15.1897L18.2367 16.4883C17.4441 16.8146 16.8147 17.444 16.4883 18.2367L15.1898 21.3902C15.1268 21.5431 14.9779 21.6429 14.8125 21.6429C14.6472 21.6429 14.4982 21.5431 14.4353 21.3902L13.1368 18.2367C12.8104 17.444 12.181 16.8146 11.3884 16.4883L8.23482 15.1897C8.08195 15.1268 7.98218 14.9778 7.98218 14.8125C7.98218 14.6472 8.08195 14.4982 8.23482 14.4353L11.3884 13.1367C12.181 12.8104 12.8104 12.181 13.1368 11.3884Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
